import { useState, useEffect } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cache = null;
let inflight = null;

// Every page load counts as a visit for everyone (increment each time).
// Module-level cache ensures a single increment per page load, shared by
// the popup and the footer so they always show the same number.
async function load() {
  if (cache) return cache;
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      const r = await fetch(`${API}/visits/register`, { method: "POST" });
      const d = await r.json();
      cache = { number: d.number, total: d.total };
    } catch (e) {
      cache = { number: null, total: null };
    }
    return cache;
  })();
  return inflight;
}

export function useVisitors() {
  const [data, setData] = useState(cache);
  useEffect(() => {
    let mounted = true;
    load().then((d) => {
      if (mounted) setData(d);
    });
    return () => {
      mounted = false;
    };
  }, []);
  return data;
}

export const formatIt = (n) =>
  typeof n === "number" ? n.toLocaleString("it-IT") : n;
